import { render, staticRenderFns } from "./IncomingInvoice.vue?vue&type=template&id=f8894280&"
import script from "./IncomingInvoice.vue?vue&type=script&lang=js&"
export * from "./IncomingInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports